import React from 'react';
import classes from "./TermsPage.module.css";
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
    const navigate = useNavigate();
    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <FaArrowLeft className="back-icon" style={{ color: "#1C1F26" }} onClick={() => navigate("/home")} />
                    <div className={classes.logo_container}
                        onClick={() => {
                            navigate("/home");
                        }}
                    >
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>

                </nav>
            </header>

                <section className={classes.termsContainer}>
                <h1 className={classes.heading}>Terms and Conditions</h1>
                <p className={classes.paragraph}><strong>Welcome to KidsDal!</strong></p>
                <p className={classes.paragraph}>
                    KidsDal is an interactive, subscription-based platform offering fun and educational content
                    designed for children aged 2-10. By subscribing to our services, you agree to the following terms
                    and conditions:
                </p>

                <h2 className={classes.subheading}>Subscription Options</h2>
                <ul className={classes.list}>
                    <li><strong>Prepaid Pack:</strong> LKR 10 – Daily access to KidsDal content. No auto-renewal.</li>
                    <li><strong>Postpaid Pack:</strong> LKR 300 – Monthly access with auto-renewal unless unsubscribed.</li>
                </ul>

                <h2 className={classes.subheading}>Content Access</h2>
                <p className={classes.paragraph}>
                    Subscribers enjoy access to a wide variety of kids learning videos, activities, and interactive
                    lessons. Content may be refreshed or updated regularly.
                </p>

                <h2 className={classes.subheading}>Renewal & Charges</h2>
                <p className={classes.paragraph}>
                    Postpaid subscriptions are automatically renewed unless cancelled via My Account. The LKR 300 fee
                    will reflect on your postpaid bill. Prepaid subscriptions require manual renewal and do not auto-renew.
                </p>

                <h2 className={classes.subheading}>Unsubscription</h2>
                <p className={classes.paragraph}>
                    You may unsubscribe anytime through the <strong>My Account</strong> section. Once unsubscribed,
                    future charges will be halted from the next billing cycle.
                </p>

                <h2 className={classes.subheading}>Disclaimer</h2>
                <p className={classes.paragraph}>
                    KidsDal reserves the right to modify pricing, content, or these terms without prior notice.
                    Users are advised to review terms periodically.
                </p>

                <p className={classes.paragraph}>
                    By continuing to use KidsDal, you acknowledge and agree to these terms.
                </p>
            </section>
        </main>
    )
}

export default TermsPage